import { z } from 'zod';
import { objectIdSchema } from './objectId';

export const PropertyType = ['sea', 'shore'] as const;

export const BrandMealPeriodSchema = z.object({
  _id: objectIdSchema,
  code: z.string(),
  name: z.string(),
  color: z.string(),
  type: z.enum(PropertyType),
});

export type BrandMealPeriod = z.infer<typeof BrandMealPeriodSchema>;
